import MatchedMap from 'utilities/src/matchedMap';
import { ButtonBGEnum } from '../../../types/_bg';

const buttonClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'px-4 rounded-lg focus:shadow-ring active:shadow-none'],
  [ButtonBGEnum.Dark, 'px-4 rounded-lg focus:shadow-ring active:shadow-none'],
]);

const buttonDisabledClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'disabled:bg-site-neutrals-200 disabled:text-site-neutrals-50'],
  [ButtonBGEnum.Dark, 'disabled:bg-site-neutrals-500 disabled:text-site-neutrals-100'],
]);

const buttonSitePrimaryClasses = [buttonClassesMap, buttonDisabledClassesMap];

export default buttonSitePrimaryClasses;
